import { Banner, Button, Skeleton } from '../../../ds/components';
import { ApiError, errorMessage } from '../../../lib/api';
import styles from './Portal.module.css';

/** Error of a portal section (Deal-Pipeline 15 pattern: danger banner with „Erneut laden"). */
export function PageError({
  what,
  error,
  onRetry,
  retrying,
}: {
  what: string;
  error: unknown;
  onRetry: () => void;
  retrying?: boolean | undefined;
}) {
  const status = error instanceof ApiError ? error.status : null;
  return (
    <Banner
      tone="danger"
      actions={
        <Button variant="destructiveFilled" size="small" loading={retrying} onClick={onRetry}>
          Erneut laden
        </Button>
      }
    >
      {what} konnte nicht geladen werden{status !== null ? ` · Fehler ${status}` : ''}. {errorMessage(error)}
    </Banner>
  );
}

/** Loading skeleton of a portal section: heading and blocks in the section's rhythm. */
export function PageSkeleton({ blocks = [220, 180] }: { blocks?: number[] }) {
  return (
    <div className={styles.content} aria-busy="true">
      <Skeleton width="28%" height={30} />
      {blocks.map((height, index) => (
        <Skeleton key={index} height={height} />
      ))}
    </div>
  );
}
